import { useSectors } from '../../../hooks/useSectors';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../select';

interface SectorSelectProps {
  value: string | null;
  onChange: (sectorId: string) => void;
}

export function SectorSelect({ value, onChange }: SectorSelectProps) {
  const { sectors, loading, error } = useSectors();

  if (loading || error) return null;

  return (
    <div className="space-y-1">
      <p className="text-sm font-medium">Sector</p>
      <Select value={value ?? ''} onValueChange={onChange}>
        <SelectTrigger className="w-full bg-white">
          <SelectValue placeholder="Assign a sector" />
        </SelectTrigger>
        <SelectContent>
          {sectors.map((s) => (
            <SelectItem key={s.id} value={s.id}>
              {s.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
